// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/react-tooltip/dist/react-tooltip.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Calibre-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23FFFFFF%27 d=%27M2 4l4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
button,
.tab-button {
  -webkit-tap-highlight-color: transparent !important;
  tap-highlight-color: transparent !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/* Add focus and active states to prevent highlights */

.tab-button:focus,
.tab-button:active,
.tab-button:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent !important;
}

/* Prevent blue highlight on active tabs */

.tab-button.active:focus,
.tab-button.active:active,
.tab-button.active:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

/* Font face declaration for Calibre-Light */

@font-face {
  font-family: 'Calibre-Light';

  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');

  font-weight: 300;

  font-style: normal;

  font-display: swap;
}

/* FIXED: Scoped font override instead of aggressive global override */

.explorer-container,
.explorer-container div:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container span:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container p:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h1:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h2:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h3:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h4:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h5:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container h6:not(.react-tooltip):not(.react-tooltip *),
.explorer-container button:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container input:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container select:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container textarea:not(.react-tooltip):not(.react-tooltip *), 
.explorer-container label:not(.react-tooltip):not(.react-tooltip *) {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 300;
}

/* Apply font to body and html without !important */

body, html {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 300;
}

/* Tooltip-specific font styling - preserves tooltip functionality */

.react-tooltip,
.react-tooltip * {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 300 !important;
  /* Ensure tooltip visibility */
  position: relative !important;
  z-index: 10000 !important;
}

/* Plotly-specific overrides - scoped to your container */

.explorer-container .plotly .gtitle, 
.explorer-container .plotly .xtitle, 
.explorer-container .plotly .ytitle,
.explorer-container .plotly .legend, 
.explorer-container .plotly .legendtext,
.explorer-container .plotly .tick, 
.explorer-container .plotly .ticktext,
.explorer-container .plotly .annotation, 
.explorer-container .plotly .annotation-text,
.explorer-container .plotly text, 
.explorer-container .plotly .annotation-text,
.explorer-container .js-plotly-plot, 
.explorer-container .js-plotly-plot text,
.explorer-container svg text, 
.explorer-container svg tspan {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 300 !important;
}

/* Globe.GL and Three.js canvas text (if any) - scoped */

.explorer-container canvas {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 300 !important;
}

/* For elements that need to be bold/semibold, override the weight */

.explorer-container h1, 
.explorer-container h2, 
.explorer-container h3, 
.explorer-container h4, 
.explorer-container h5, 
.explorer-container h6, 
.explorer-container .app-title, 
.explorer-container .header-title,
.explorer-container .button-primary {
  font-weight: 400;
}

/* For very important elements that need more weight */

.explorer-container .app-title, 
.explorer-container .header-title {
  font-weight: 500;
}

/* Super bold title class - keeps Calibre-Light but makes it much bolder */

.super-bold-title {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 700 !important;
  font-size: 1.5rem !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.1) !important;
  color: #1a365d !important;
}

/* Alternative approach using CSS transforms for even more emphasis */

.ultra-emphasis {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 700 !important;
  transform: scaleX(1.05) !important;
  letter-spacing: 1px !important;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.15) !important;
  color: #0f172a !important;
}

.explorer-container {
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}

/* ============================================
   SIDEBAR STYLES - Dark Theme (Framework Visualizer Style)
   ============================================ */

.sidebar {
  width: 320px;
  background: linear-gradient(180deg, #113743 0%, #0a2029 100%);
  color: white;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  position: relative;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: visible;
}

.sidebar.open {
  width: 320px;
}

.sidebar.collapsed {
  width: 48px;
}

.sidebar.collapsed .sidebar-content {
  display: none;
}

.sidebar-content {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.sidebar-toggle {
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #113743;
  border: 2px solid white;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.sidebar-toggle:hover {
  background: #1a4f5e;
  transform: translateY(-50%) scale(1.1);
}

/* ============================================
   SECTION STYLES - Dark Theme
   ============================================ */

.section {
  margin-bottom: 1.25rem;
}

.section-title {
  font-size: 0.75rem !important;
  font-weight: 700 !important;  /* Changed from 600 to 700 */
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #E2E8F0 !important;  /* Changed from #94A3B8 to whiter */
  margin: 0 0 0.5rem 0 !important;
}

/* ============================================
   SELECT INPUT STYLES - Dark Theme
   ============================================ */

.select-input {
  width: 100%;
  padding: 0.625rem 0.875rem;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px;
  color: #FFFFFF !important;  /* Ensure pure white */
  font-size: 0.875rem;
  font-weight: 500 !important;  /* Add some weight */
  cursor: pointer;
  transition: all 0.2s;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;  /* White arrow */
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
}

.select-input:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.select-input:focus {
  outline: none;
  border-color: #1a5c6b !important;
  box-shadow: 0 0 0 2px rgba(17, 55, 67, 0.3);
}

.select-input option {
  background: #1E293B;
  color: white;
}

.select-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   TAB SELECTOR STYLES - Dark Theme
   ============================================ */

.tab-selector {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.tab-button {
  flex: 1 1;
  padding: 0.625rem 0.875rem;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px;
  color: #94A3B8 !important;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.tab-button:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
}

.tab-button.active {
  background: rgba(17, 55, 67, 0.4) !important;
  border-color: #1a5c6b !important;
  color: #5ec4d4 !important;
}

.tab-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Super bold button class for dark theme */

.super-bold-button {
  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.8125rem !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase !important;
}

.super-bold-button.active {
  font-weight: 700 !important;
}

/* ============================================
   CHART VIEW SELECTOR - Dark Theme
   ============================================ */

.chart-view-selector {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

/* ============================================
   BUTTON STYLES - Dark Theme
   ============================================ */

.button {
  width: 100%;
  padding: 0.625rem 0.875rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.button-primary {
  background-color: #113743;
  border: none;
  color: white;
}

.button-primary:hover {
  background-color: #1a5c6b;
}

.button-secondary {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #CBD5E1 !important;
}

.button-secondary:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  color: white !important;
}

.button-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   DROPDOWN STYLES - Dark Theme
   ============================================ */

.dropdown-container {
  position: relative;
  width: 100%;
}

.dropdown-header {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.dropdown-header:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.dropdown-search-input {
  flex: 1 1;
  padding: 0.625rem 0.875rem;
  background: transparent !important;
  border: none !important;
  color: #E2E8F0 !important;
  font-size: 0.875rem;
  outline: none;
}

.dropdown-search-input::placeholder {
  color: #E2E8F0 !important;
}

.dropdown-arrow {
  padding: 0 0.75rem;
  color: #E2E8F0;
  font-size: 0.625rem;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 280px;
  overflow-y: auto;
  background: #1E293B !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}

.dropdown-actions {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.dropdown-action-button {
  flex: 1 1;
  padding: 0.375rem 0.5rem;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 4px;
  color: #CBD5E1 !important;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;
}

.dropdown-action-button:hover {
  background: rgba(17, 55, 67, 0.3) !important;
  color: #5ec4d4 !important;
}

.dropdown-item {
  padding: 0.625rem 0.875rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #E2E8F0 !important;
  transition: all 0.15s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: rgba(17, 55, 67, 0.3) !important;
  color: white !important;
}

.dropdown-item.selected {
  background: rgba(17, 55, 67, 0.4) !important;
  color: #5ec4d4 !important;
}

.dropdown-item.no-options {
  color: #64748B !important;
  cursor: default;
  justify-content: center;
}

.dropdown-item.no-options:hover {
  background: transparent !important;
}

.dropdown-item input[type="checkbox"] {
  accent-color: #113743;
}

.dropdown-section-header {
  padding: 12px 16px 8px 16px;
  color: #94A3B8 !important;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(255, 255, 255, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.dropdown-divider {
  padding: 8px 12px;
  color: #64748B !important;
  font-size: 12px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02) !important;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.group-item {
  padding-left: 24px !important;
}

/* ============================================
   INFO ICON STYLES - Dark Theme
   ============================================ */

.custom-info-icon {
  color: #5ec4d4 !important;
  font-size: 0.875rem;
  transition: color 0.2s;
  cursor: help;
  display: inline-block;
  line-height: 1;
}

.custom-info-icon:hover {
  color: #7dd4e0 !important;
}

/* Style for the button containing the info icon in sidebar */

.sidebar button.text-blue-500 {
  background: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  vertical-align: middle;
  cursor: help;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease;
}

.sidebar button.text-blue-500:hover .custom-info-icon {
  color: #7dd4e0 !important;
}

.sidebar button.text-blue-500:focus {
  outline: 2px solid #113743;
  outline-offset: 2px;
  border-radius: 2px;
}

/* ============================================
   SCROLLBAR STYLES - Dark Theme for Sidebar
   ============================================ */

.sidebar-content::-webkit-scrollbar,
.sidebar .dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.sidebar-content::-webkit-scrollbar-track,
.sidebar .dropdown-menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-content::-webkit-scrollbar-thumb,
.sidebar .dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover,
.sidebar .dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ============================================
   HEADER STYLES (Legacy - kept for compatibility)
   ============================================ */

.header-section {
  margin-bottom: 16px;
  flex-shrink: 0;
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.app-logo {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  display: block;
  max-width: none;
}

.app-logo-link {
  display: block;
  cursor: pointer;
  text-decoration: none;
  width: 100%;
}

.app-logo-link:hover {
  opacity: 0.8;
}

.app-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: white;
  text-align: center;
}

/* ============================================
   TOOLTIP STYLES
   ============================================ */

/* Ensure inline-flex container keeps title and icon on the same line */

.inline-flex.items-center {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}

/* ENHANCED TOOLTIP STYLING FOR REACT-TOOLTIP */

.react-tooltip {
  position: absolute !important;
  z-index: 10000 !important;
  background-color: #1F2937 !important;
  color: #FFFFFF !important;
  max-width: 500px !important;
  min-width: 200px !important;
  max-height: 350px !important;
  overflow-y: auto !important;
  padding: 12px 15px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  word-wrap: break-word !important;
  hyphens: auto !important;
  white-space: pre-line !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  pointer-events: none !important;
  opacity: 1 !important;
  transition: opacity 0.2s ease !important;
}

/* Specific styling for different tooltip placements */

.react-tooltip[data-place="bottom"] {
  margin-top: 8px !important;
}

.react-tooltip[data-place="right"] {
  margin-left: 8px !important;
}

.react-tooltip[data-place="left"] {
  margin-right: 8px !important;
}

.react-tooltip[data-place="top"] {
  margin-bottom: 8px !important;
}

/* Enhanced scrollbar for long tooltip content */

.react-tooltip::-webkit-scrollbar {
  width: 6px;
}

.react-tooltip::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.react-tooltip::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
}

.react-tooltip::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Firefox scrollbar styling */

.react-tooltip {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
}

/* Ensure tooltip content is readable for very long text */

.react-tooltip p {
  margin: 0 0 8px 0;
  line-height: 1.5;
}

.react-tooltip p:last-child {
  margin-bottom: 0;
}

/* Special handling for header tooltips which might be very long */

[data-tooltip-id="header-variable-tooltip"] + .react-tooltip {
  max-width: 600px !important;
  max-height: 400px !important;
}

/* ============================================
   YEAR SLIDER STYLES
   ============================================ */

.year-slider-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.play-pause-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  margin-right: 5px;
  color: #333;
  transition: color 0.2s;
}

.play-pause-button:hover:not(:disabled) {
  color: #3b82f6;
}

.play-pause-button:disabled {
  color: #9ca3af;
  cursor: not-allowed;
}

.year-slider {
  flex-grow: 1;
  appearance: none;
  height: 8px;
  background: #d1d5db;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}

.year-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 2px rgba(0,0,0,0.3);
}

.year-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 2px rgba(0,0,0,0.3);
}

.year-slider:disabled {
  background: #e5e7eb;
  cursor: not-allowed;
}

.year-slider:disabled::-webkit-slider-thumb {
  background: #9ca3af;
}

.year-slider:disabled::-moz-range-thumb {
  background: #9ca3af;
}

.year-label {
  min-width: 60px;
  font-size: 14px;
  color: #333;
  text-align: right;
}

/* Map toggle button */

.map-toggle-button {
  display: block;
  width: 100%;
  padding: 8px 12px;
  margin-top: 8px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  background-color: #e5e7eb;
  color: #1f2937;
}

.map-toggle-button:hover {
  background-color: #d1d5db;
}

/* ============================================
   MAIN CONTENT AREA STYLES
   ============================================ */

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  z-index: 5;
  position: relative;
  overflow: hidden;
  width: auto !important;
  min-width: 300px;
  transition: all 0.3s ease;
}

/* Better responsive width calculations */

.explorer-container[data-right-panel-open="true"] .main-content {
  width: calc(100vw - var(--sidebar-width, 320px) - 350px) !important;
  min-width: 300px;
}

.explorer-container[data-right-panel-open="false"] .main-content {
  width: calc(100vw - var(--sidebar-width, 320px)) !important;
  min-width: 300px;
}

.header {
  flex-shrink: 0;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #111;
  display: inline;
  white-space: nowrap;
}

.header-description {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* Fix content area to be more responsive */

.content-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: stretch;
  min-height: 600px;
  transition: width 0.3s ease;
}

/* Map controls */

.map-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
  z-index: 1000;
}

.map-controls .button {
  padding: 6px 10px;
  font-size: 12px;
  margin-top: 0;
}

/* ============================================
   RIGHT PANEL STYLES
   ============================================ */

.right-panel {
  flex: 0 0 350px;
  max-width: 350px;
  background-color: #f9f9f9;
  border-left: 1px solid #e0e0e0;
  transition: flex-basis 0.3s ease, max-width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  z-index: 20;
}

.right-panel.collapsed {
  flex: 0 0 40px;
  max-width: 40px;
}

.right-panel.collapsed .panel-content {
  display: none;
}

.panel-toggle {
  position: absolute;
  top: 20px;
  left: -15px;
  background-color: #3b82f6;
  color: white;
  border: 2px solid white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.panel-toggle:hover {
  background-color: #2563eb;
}

.panel-toggle-text {
  background-color: #3b82f6;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  transition: background-color 0.2s;
  width: auto;
  display: inline-block;
  margin: 10px;
}

.panel-toggle-text:hover {
  background-color: #2563eb;
}

.right-panel.collapsed .panel-toggle-text {
  position: absolute;
  top: 10px;
  right: 10px;
}

.right-panel.open .panel-toggle-text {
  position: relative;
  margin-bottom: 10px;
}

.panel-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  position: relative;
}

/* ============================================
   METADATA STYLES
   ============================================ */

.metadata-toggle-button {
  background-color: #3b82f6;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  transition: background-color 0.2s;
  margin-bottom: 1rem;
}

.metadata-toggle-button:hover {
  background-color: #2563eb;
}

.metadata-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.metadata-popup {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 600px;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.metadata-popup h3 {
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1F2937;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.metadata-popup button {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6B7280;
}

.metadata-fields {
  display: grid;
  gap: 1rem;
}

.metadata-field {
  border-bottom: 1px solid #E5E7EB;
  padding-bottom: 0.75rem;
}

.metadata-field dt {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.metadata-field dd {
  font-size: 0.875rem;
  color: #1F2937;
  margin: 0;
  word-break: break-word;
}

.metadata-field a {
  color: #1a5c6b;
  text-decoration: underline;
}

.no-metadata {
  color: #6B7280;
  font-style: italic;
}

/* ============================================
   TABLE STYLES
   ============================================ */

.table-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
}

.table-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  flex-shrink: 0;
}

.table-container {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100%;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.data-table thead tr {
  display: flex;
  background-color: #f4f4f4;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table th,
.data-table td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
  flex: 1 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.data-table th {
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 4px;
}

.data-table tbody tr {
  display: flex;
}

.data-table th:nth-child(1),
.data-table td:nth-child(1) {
  flex: 2 1;
}

.data-table th:nth-child(2),
.data-table td:nth-child(2) {
  flex: 1 1;
  text-align: center;
}

.data-table th:nth-child(3),
.data-table td:nth-child(3) {
  flex: 1.5 1;
  text-align: right;
}

.data-table .sort-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #3b82f6;
  padding: 0;
  margin-left: 4px;
}

.data-table .sort-button:hover {
  color: #2563eb;
}

.data-table tr.row-even {
  background-color: #fafafa;
}

.data-table tr.row-odd {
  background-color: #ffffff;
}

.table-footer {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  text-align: center;
  flex-shrink: 0;
}

/* ============================================
   MAP VISUALIZATION STYLES
   ============================================ */

.map-view-wrapper {
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 0;
  max-height: calc(100vh - 120px);
  transition: all 0.3s ease;
  overflow: hidden;
}

.map-view-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1;
  overflow: hidden;
  z-index: 10;
  transition: all 0.3s ease;
}

.map-view-container[data-mode="2d"] .globe-container {
  display: none;
}

.map-view-container[data-mode="3d"] .world-map,
.map-view-container[data-mode="3d"] .legend-container {
  display: none;
}

.region-select {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #333;
  z-index: 1000;
  cursor: pointer;
}

/* Fix map visualization container to resize properly */

.map-visualization-container {
  width: 100% !important;
  height: 100% !important;
  flex: 1 1 !important;
  position: relative !important;
  display: flex !important;
  justify-content: stretch !important;
  align-items: stretch !important;
  min-height: 400px !important;
  overflow: hidden !important;
  transition: all 0.3s ease !important;
}

.map-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9fafb;
  color: #6b7280;
  border-radius: 8px;
}

.world-map {
  flex: 0 0 85%;
  height: 100%;
  display: block;
  margin: 0;
  transition: all 0.3s ease;
}

.world-map path {
  transition: fill 0.3s ease, stroke 0.2s ease, stroke-width 0.2s ease;
}

.world-map path:hover {
  stroke: #333;
  stroke-width: 1px;
  cursor: pointer;
}

.world-map path.has-data {
  cursor: pointer;
}

.globe-container {
  width: 100%;
  height: 100%;
  display: block;
  z-index: 5;
  transition: all 0.3s ease;
}

.map-data-status {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

.map-error {
  padding: 20px;
  background-color: #fff3f3;
  border: 1px solid #ffcccb;
  border-radius: 5px;
}

/* Compact year slider positioning */

.map-view-container .year-slider-container {
  position: absolute !important;
  bottom: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  z-index: 1000 !important;
  width: auto !important;
  height: auto !important;
  min-width: 300px !important;
  max-width: 400px !important;
  flex-shrink: 0 !important;
}

/* Compact play button styles */

.map-view-container .year-slider-container .play-pause-button {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
  border: 1px solid #ccc !important;
  background-color: #fff !important;
  cursor: pointer !important;
  font-size: 10px !important;
  margin-right: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Compact slider styles */

.map-view-container .year-slider-container .year-slider {
  width: 180px !important;
  margin: 0 8px !important;
  height: 4px !important;
  cursor: pointer !important;
}

/* Compact year label styles */

.map-view-container .year-slider-container .year-label {
  min-width: 40px !important;
  text-align: center !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #333 !important;
}

.legend-container {
  flex: 0 0 15%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  transition: all 0.3s ease;
}

.color-scale {
  width: 20px;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, #6baed6, #f7f7f7, #ef3b2c);
  border-radius: 4px;
  position: relative;
  padding: 4px 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.color-scale span {
  position: relative;
  font-size: 12px;
  color: #333;
  text-align: center;
  margin: 0 5px;
  font-weight: 500;
}

/* ============================================
   CHART VISUALIZATION STYLES
   ============================================ */

.chart-view-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: all 0.3s ease;
}

.chart-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.chart-control-group {
  display: flex;
  flex-direction: column;
  min-width: 150px;
}

.chart-control-group label {
  font-size: 14px;
  margin-bottom: 5px;
  color: #4b5563;
}

.chart-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #333;
}

/* Plotly chart container fixes */

.plotly-chart-container {
  width: 100% !important;
  height: 100% !important;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.no-data-message {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #6b7280;
  text-align: center;
}

.plotly-chart {
  width: 100% !important;
  height: 100% !important;
  transition: all 0.3s ease;
}

/* Filter status */

.filter-info {
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
  margin-bottom: 0;
}

.filter-warning {
  color: #d32f2f;
  font-weight: bold;
  margin-top: 4px;
}

.filter-status {
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}

/* Export buttons */

.export-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

/* Debug controls */

.debug-controls {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

/* Map tooltip */

.map-tooltip {
  position: absolute;
  display: none;
  padding: 8px 12px;
  background-color: rgba(0,0,0,0.8);
  color: white;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 1000;
}

/* Loading state */

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}

/* Remove any existing year controls that might be in the main content area */

.content-area > .year-controls {
  display: none !important;
}

/* Year controls - legacy styles (kept for compatibility) */

.year-controls {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 0;
  padding: 10px 0;
  background-color: #f9f9f9;
  border-top: 1px solid #e0e0e0;
}

/* ENHANCED TOOLTIP VISIBILITY AND PERFORMANCE FIXES */

/* Force tooltip to always be visible when active */

.react-tooltip.show {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: none !important;
}

/* Prevent tooltip content from being cut off */

.react-tooltip.type-dark {
  background-color: #1F2937 !important;
  border: 1px solid #374151 !important;
}

/* Better contrast for tooltip text */

.react-tooltip.type-dark.place-top:after,
.react-tooltip.type-dark.place-bottom:after,
.react-tooltip.type-dark.place-left:after,
.react-tooltip.type-dark.place-right:after {
  border-color: #374151 !important;
}

/* Ensure tooltip arrows are visible */

.react-tooltip:after {
  border-width: 6px !important;
  margin-left: -6px !important;
}

/* Special handling for tooltip content with line breaks */

.react-tooltip br {
  line-height: 1.8 !important;
}

/* Enhanced focus states for accessibility */

button[data-tooltip-id]:focus {
  outline: 2px solid #3b82f6 !important;
  outline-offset: 2px !important;
  border-radius: 3px !important;
}

/* Ensure tooltips work well with screen readers */

button[data-tooltip-id] {
  position: relative;
}

button[data-tooltip-id]:focus .custom-info-icon,
button[data-tooltip-id]:active .custom-info-icon {
  color: #93C5FD !important;
}

.watermarks-container {
  /* Ensure watermarks stay above other content but below modals */
  z-index: 1000;
}

/* ============================================
   RESPONSIVE STYLES
   ============================================ */

@media (max-width: 1200px) {
  .explorer-container[data-right-panel-open="true"] .main-content {
    width: calc(100vw - var(--sidebar-width, 320px) - 300px) !important;
  }

  .right-panel {
    flex: 0 0 300px;
    max-width: 300px;
  }

  .sidebar {
    width: 280px;
  }

  .sidebar.open {
    width: 280px;
  }
}

@media (max-width: 1024px) {
  .explorer-container {
    flex-direction: column;
    height: auto;
  }

  .sidebar {
    width: 100% !important;
    max-width: 100%;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    max-height: 50vh;
  }

  .sidebar.collapsed {
    height: 48px;
    width: 100% !important;
    max-height: 48px;
  }

  .sidebar-toggle {
    right: 50%;
    top: auto;
    bottom: -16px;
    transform: translateX(50%);
  }

  .main-content {
    width: 100% !important;
    flex: 1 1;
    min-height: 500px;
    min-width: auto;
  }

  .explorer-container[data-right-panel-open="true"] .main-content,
    .explorer-container[data-right-panel-open="false"] .main-content {
    width: 100% !important;
    min-width: auto;
  }

  .right-panel {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
    border-left: none;
    border-top: 1px solid #e0e0e0;
    height: auto;
  }

  .right-panel.collapsed {
    height: 40px;
    width: 100%;
  }

  .panel-toggle {
    left: auto;
    right: 10px;
    top: 20px;
    transform: none;
  }

  .panel-toggle-text {
    right: 10px;
    top: 10px;
    margin: 0;
    width: auto;
    padding: 6px 12px;
  }

  .right-panel.open .panel-toggle-text {
    margin: 10px;
    width: auto;
    padding: 6px 12px;
  }

  .title-wrapper {
    justify-content: center;
    padding-right: 0;
  }

  .app-logo {
    max-width: 150px;
    margin-left: auto;
    margin-right: auto;
  }

  .region-select {
    top: 5px;
    right: 5px;
  }

  .map-controls {
    flex-direction: column;
    align-items: flex-end;
  }

  .world-map {
    flex: 0 0 100%;
  }

  .legend-container {
    flex: 0 0 100%;
    height: 40px;
    margin: 10px 0;
    flex-direction: row;
  }

  .color-scale {
    width: 100%;
    max-width: 400px;
    height: 20px;
    flex-direction: row;
    background: linear-gradient(to right, #6baed6, #f7f7f7, #ef3b2c);
    padding: 0 10px;
  }

  .color-scale span {
    margin: 0;
  }

  .data-table th,
    .data-table td {
    font-size: 11px;
    padding: 6px;
  }

  .tab-button {
    padding: 0.5rem 0.625rem;
    font-size: 0.75rem;
    min-width: 60px;
  }

  /* Responsive adjustments for map view wrapper */

  .map-view-wrapper {
    height: calc(100vh - 200px);
    max-height: calc(100vh - 200px);
  }

  .map-view-container .year-slider-container {
    min-width: 280px !important;
    max-width: 350px !important;
    padding: 6px 12px !important;
  }

  .map-view-container .year-slider-container .year-slider {
    width: 160px !important;
  }

  .metadata-popup {
    max-width: 500px;
    width: 90%;
    padding: 1.5rem;
  }

  .watermarks-container {
    bottom: 10px !important;
    left: 10px !important;
    right: 10px !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .watermarks-container > div {
    font-size: 10px !important;
  }

  .watermarks-container img {
    height: 30px !important;
  }
}

@media (max-width: 768px) {
  .react-tooltip {
    max-width: 90vw !important;
    max-height: 60vh !important;
    font-size: 12px !important;
    padding: 10px 12px !important;
  }

  [data-tooltip-id="header-variable-tooltip"] + .react-tooltip {
    max-width: 95vw !important;
    max-height: 70vh !important;
  }
}

@media (max-width: 640px) {
  .table-container {
    overflow-x: auto;
  }

  .chart-controls {
    flex-direction: column;
  }

  .chart-control-group {
    width: 100%;
  }

  .app-title {
    font-size: 16px;
  }

  .title-wrapper {
    padding-right: 0;
  }

  .region-select {
    font-size: 12px;
    padding: 6px;
  }

  .map-controls .button {
    font-size: 10px;
    padding: 4px 8px;
  }

  .app-logo {
    max-width: 120px;
  }

  .data-table th,
    .data-table td {
    font-size: 10px;
    padding: 4px;
  }

  .panel-toggle-text {
    padding: 4px 8px;
    font-size: 12px;
  }

  .tab-button {
    padding: 0.375rem 0.5rem;
    font-size: 0.6875rem;
    min-width: 50px;
  }

  /* Mobile responsive adjustments for compact year slider */

  .map-view-wrapper {
    height: calc(100vh - 250px);
    max-height: calc(100vh - 250px);
  }

  .map-view-container .year-slider-container {
    min-width: 250px !important;
    max-width: 300px !important;
    padding: 6px 10px !important;
    bottom: 10px !important;
  }

  .map-view-container .year-slider-container .year-slider {
    width: 140px !important;
    margin: 0 6px !important;
  }

  .map-view-container .year-slider-container .play-pause-button {
    width: 20px !important;
    height: 20px !important;
    font-size: 8px !important;
    margin-right: 6px !important;
  }

  .map-view-container .year-slider-container .year-label {
    font-size: 11px !important;
    min-width: 35px !important;
  }

  .metadata-popup {
    max-width: 95%;
    width: 95%;
    max-height: 85vh;
    padding: 1rem;
  }

  .metadata-popup h3 {
    font-size: 1.125rem;
    margin-bottom: 1rem;
  }

  .metadata-field dt {
    font-size: 0.8125rem;
  }

  .metadata-field dd {
    font-size: 0.8125rem;
  }

  /* Mobile tooltip adjustments */

  .react-tooltip {
    max-width: 95vw !important;
    font-size: 12px !important;
    padding: 10px 12px !important;
  }
}

/* Ensure watermarks don't interfere with sidebar */

.explorer-container[data-sidebar-open="true"] .watermarks-container {
  left: calc(var(--sidebar-width, 320px) + 20px) !important;
}

.explorer-container[data-sidebar-open="false"] .watermarks-container {
  left: 60px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/OECDExplorer.css"],"names":[],"mappings":"AAEA;;;EAGE,mDAAmD;EACnD,2CAA2C;EAC3C,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,sDAAsD;;AACtD;;;EAGE,wBAAwB;EACxB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA,0CAA0C;;AAC1C;;;EAGE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,4CAA4C;;AAC5C;EACE,4BAA4B;;EAC5B,+DAA8D;;EAC9D,gBAAgB;;EAChB,kBAAkB;;EAClB,kBAAkB;AACpB;;AAEA,sEAAsE;;AACtE;;;;;;;;;;;;;;;EAeE,yJAAyJ;EACzJ,gBAAgB;AAClB;;AAEA,mDAAmD;;AACnD;EACE,yJAAyJ;EACzJ,gBAAgB;AAClB;;AAEA,oEAAoE;;AACpE;;EAEE,oKAAoK;EACpK,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,yDAAyD;;AACzD;;;;;;;;;;;;;;;EAeE,oKAAoK;EACpK,2BAA2B;AAC7B;;AAEA,wDAAwD;;AACxD;EACE,oKAAoK;EACpK,2BAA2B;AAC7B;;AAEA,oEAAoE;;AACpE;;;;;;;;;EASE,gBAAgB;AAClB;;AAEA,sDAAsD;;AACtD;;EAEE,gBAAgB;AAClB;;AAEA,0EAA0E;;AAC1E;EACE,oKAAoK;EACpK,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,uDAAuD;EACvD,yBAAyB;AAC3B;;AAEA,qEAAqE;;AACrE;EACE,oKAAoK;EACpK,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC7B;;AAEA;;iDAEiD;;AACjD;EACE,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;iDAEiD;;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B,GAAG,4BAA4B;EAC1D,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB,GAAG,mCAAmC;EAC/D,+BAA+B;AACjC;;AAEA;;iDAEiD;;AACjD;EACE,WAAW;EACX,0BAA0B;EAC1B,+CAA+C;EAC/C,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB,GAAG,sBAAsB;EAClD,mBAAmB;EACnB,2BAA2B,GAAG,oBAAoB;EAClD,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oEAAqM,GAAG,gBAAgB;EACxN,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AACjD;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,+CAA+C;EAC/C,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2CAA2C;;AAC3C;EACE,oKAAoK;EACpK,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AACjD;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;iDAEiD;;AACjD;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AACjD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;EACrD,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,qDAAqD;EACrD,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,+CAA+C;EAC/C,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;EAChD,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;iDAEiD;;AACjD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;;AAC7D;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;iDAEiD;;AACjD;;EAEE,UAAU;AACZ;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;iDAEiD;;AACjD;EACI,mBAAmB;EACnB,cAAc;AAClB;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACvB;;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACtB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;AACnB;;AAEA;EACI,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,WAAW;AACf;;AAEA;EACI,YAAY;AAChB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACtB;;AAEA;;iDAEiD;;AACjD,uEAAuE;;AACvE;EACI,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACZ;;AAEA,+CAA+C;;AAC/C;EACI,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;EAChC,gGAAgG;EAChG,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;AAC5C;;AAEA,sDAAsD;;AACtD;EACI,0BAA0B;AAC9B;;AAEA;EACI,2BAA2B;AAC/B;;AAEA;EACI,4BAA4B;AAChC;;AAEA;EACI,6BAA6B;AACjC;;AAEA,gDAAgD;;AAChD;EACI,UAAU;AACd;;AAEA;EACI,oCAAoC;EACpC,kBAAkB;AACtB;;AAEA;EACI,oCAAoC;EACpC,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AACpC;;AAEA;EACI,oCAAoC;AACxC;;AAEA,8BAA8B;;AAC9B;EACI,qBAAqB;EACrB,kEAAkE;AACtE;;AAEA,0DAA0D;;AAC1D;EACI,iBAAiB;EACjB,gBAAgB;AACpB;;AAEA;EACI,gBAAgB;AACpB;;AAEA,kEAAkE;;AAClE;EACI,2BAA2B;EAC3B,4BAA4B;AAChC;;AAEA;;iDAEiD;;AACjD;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACf;;AAEA;EACI,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AAC1B;;AAEA;EACI,cAAc;AAClB;;AAEA;EACI,cAAc;EACd,mBAAmB;AACvB;;AAEA;EACI,YAAY;EAEZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACnB;;AAEA;EAEI,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACvC;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACvC;;AAEA;EACI,mBAAmB;EACnB,mBAAmB;AACvB;;AAEA;EACI,mBAAmB;AACvB;;AAEA;EACI,mBAAmB;AACvB;;AAEA;EACI,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;AACrB;;AAEA,sBAAsB;;AACtB;EACI,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAClB;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;;iDAEiD;;AACjD;EACI,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC7B;;AAEA,yCAAyC;;AACzC;EACI,mEAAmE;EACnE,gBAAgB;AACpB;;AAEA;EACI,2DAA2D;EAC3D,gBAAgB;AACpB;;AAEA;EACI,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACvB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;AACvB;;AAEA;EACI,eAAe;EACf,WAAW;EACX,SAAS;AACb;;AAEA,2CAA2C;;AAC3C;EACI,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;AAC/B;;AAEA,iBAAiB;;AACjB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;EACT,aAAa;AACjB;;AAEA;EACI,iBAAiB;EACjB,eAAe;EACf,aAAa;AACjB;;AAEA;;iDAEiD;;AACjD;EACI,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACf;;AAEA;EACI,cAAc;EACd,eAAe;AACnB;;AAEA;EACI,aAAa;AACjB;;AAEA;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC5C;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,qBAAqB;EACrB,YAAY;AAChB;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;AACf;;AAEA;EACI,kBAAkB;EAClB,mBAAmB;AACvB;;AAEA;EACI,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACtB;;AAEA;;iDAEiD;;AACjD;EACI,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACvB;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACjB;;AAEA;EACI,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iDAAiD;AACrD;;AAEA;EACI,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACvB;;AAEA;EACI,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAClB;;AAEA;EACI,aAAa;EACb,SAAS;AACb;;AAEA;EACI,gCAAgC;EAChC,uBAAuB;AAC3B;;AAEA;EACI,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AAC1B;;AAEA;EACI,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,sBAAsB;AAC1B;;AAEA;EACI,cAAc;EACd,0BAA0B;AAC9B;;AAEA;EACI,cAAc;EACd,kBAAkB;AACtB;;AAEA;;iDAEiD;;AACjD;EACI,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACjB;;AAEA;EACI,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAClB;;AAEA;EACI,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACnB;;AAEA;EACI,WAAW;EACX,yBAAyB;EACzB,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACf;;AAEA;;EAEI,YAAY;EACZ,6BAA6B;EAC7B,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACf;;AAEA;EACI,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACZ;;AAEA;EACI,aAAa;AACjB;;AAEA;;EAEI,SAAO;AACX;;AAEA;;EAEI,SAAO;EACP,kBAAkB;AACtB;;AAEA;;EAEI,WAAS;EACT,iBAAiB;AACrB;;AAEA;EACI,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,gBAAgB;AACpB;;AAEA;EACI,cAAc;AAClB;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,yBAAyB;AAC7B;;AAEA;EACI,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAClB;;AAEA;;iDAEiD;;AACjD;EACI,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AACpB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC7B;;AAEA;EACI,aAAa;AACjB;;AAEA;;EAEI,aAAa;AACjB;;AAEA;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,aAAa;EACb,eAAe;AACnB;;AAEA,uDAAuD;;AACvD;EACI,sBAAsB;EACtB,uBAAuB;EACvB,oBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;AACxC;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACtB;;AAEA;EACI,aAAa;EACb,YAAY;EACZ,cAAc;EACd,SAAS;EACT,yBAAyB;AAC7B;;AAEA;EACI,oEAAoE;AACxE;;AAEA;EACI,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACnB;;AAEA;EACI,eAAe;AACnB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,yBAAyB;AAC7B;;AAEA;EACI,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACtB;;AAEA;EACI,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACtB;;AAEA,oCAAoC;;AACpC;EACI,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,sCAAsC;EACtC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,qDAAqD;EACrD,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,oDAAoD;EACpD,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC7B;;AAEA,+BAA+B;;AAC/B;EACI,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACtC;;AAEA,0BAA0B;;AAC1B;EACI,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;AAC9B;;AAEA,8BAA8B;;AAC9B;EACI,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AAC1B;;AAEA;EACI,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC7B;;AAEA;EACI,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACzC;;AAEA;EACI,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AACpB;;AAEA;;iDAEiD;;AACjD;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC7B;;AAEA;EACI,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC7B;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AACpB;;AAEA;EACI,eAAe;EACf,kBAAkB;EAClB,cAAc;AAClB;;AAEA;EACI,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACf;;AAEA,iCAAiC;;AACjC;EACI,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AACpB;;AAEA;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACtB;;AAEA;EACI,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC7B;;AAEA,kBAAkB;;AAClB;EACI,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AACpB;;AAEA;EACI,cAAc;EACd,iBAAiB;EACjB,eAAe;AACnB;;AAEA;EACI,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACtB;;AAEA,mBAAmB;;AACnB;EACI,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AACpB;;AAEA,mBAAmB;;AACnB;EACI,gBAAgB;EAChB,aAAa;EACb,SAAS;AACb;;AAEA,gBAAgB;;AAChB;EACI,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACjB;;AAEA,kBAAkB;;AAClB;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;AAChB;;AAEA,6EAA6E;;AAC7E;EACI,wBAAwB;AAC5B;;AAEA,2DAA2D;;AAC3D;EACI,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AACjC;;AAEA,sDAAsD;;AACtD,mDAAmD;;AACnD;EACI,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACnC;;AAEA,+CAA+C;;AAC/C;EACI,oCAAoC;EACpC,oCAAoC;AACxC;;AAEA,qCAAqC;;AACrC;;;;EAII,gCAAgC;AACpC;;AAEA,sCAAsC;;AACtC;EACI,4BAA4B;EAC5B,4BAA4B;AAChC;;AAEA,0DAA0D;;AAC1D;EACI,2BAA2B;AAC/B;;AAEA,4CAA4C;;AAC5C;EACI,qCAAqC;EACrC,8BAA8B;EAC9B,6BAA6B;AACjC;;AAEA,kDAAkD;;AAClD;EACI,kBAAkB;AACtB;;AAEA;;EAEI,yBAAyB;AAC7B;;AAEA;EACI,gEAAgE;EAChE,aAAa;AACjB;;AAEA;;iDAEiD;;AACjD;EACI;IACI,mEAAmE;EACvE;;EAEA;IACI,eAAe;IACf,gBAAgB;EACpB;;EAEA;IACI,YAAY;EAChB;;EAEA;IACI,YAAY;EAChB;AACJ;;AAEA;EACI;IACI,sBAAsB;IACtB,YAAY;EAChB;;EAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,iDAAiD;IACjD,gBAAgB;EACpB;;EAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;EACpB;;EAEA;IACI,UAAU;IACV,SAAS;IACT,aAAa;IACb,0BAA0B;EAC9B;;EAEA;IACI,sBAAsB;IACtB,SAAO;IACP,iBAAiB;IACjB,eAAe;EACnB;;EAEA;;IAEI,sBAAsB;IACtB,eAAe;EACnB;;EAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;EAChB;;EAEA;IACI,YAAY;IACZ,WAAW;EACf;;EAEA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,eAAe;EACnB;;EAEA;IACI,WAAW;IACX,SAAS;IACT,SAAS;IACT,WAAW;IACX,iBAAiB;EACrB;;EAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;EACrB;;EAEA;IACI,uBAAuB;IACvB,gBAAgB;EACpB;;EAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACtB;;EAEA;IACI,QAAQ;IACR,UAAU;EACd;;EAEA;IACI,sBAAsB;IACtB,qBAAqB;EACzB;;EAEA;IACI,cAAc;EAClB;;EAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,mBAAmB;EACvB;;EAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gEAAgE;IAChE,eAAe;EACnB;;EAEA;IACI,SAAS;EACb;;EAEA;;IAEI,eAAe;IACf,YAAY;EAChB;;EAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;EACnB;;EAEA,gDAAgD;;EAChD;IACI,2BAA2B;IAC3B,+BAA+B;EACnC;;EAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;EAChC;;EAEA;IACI,uBAAuB;EAC3B;;EAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;EACnB;;EAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACZ;;EAEA;IACI,0BAA0B;EAC9B;;EAEA;IACI,uBAAuB;EAC3B;AACJ;;AAEA;EACI;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;EACjC;;EAEA;IACI,0BAA0B;IAC1B,2BAA2B;EAC/B;AACJ;;AAEA;EACI;IACI,gBAAgB;EACpB;;EAEA;IACI,sBAAsB;EAC1B;;EAEA;IACI,WAAW;EACf;;EAEA;IACI,eAAe;EACnB;;EAEA;IACI,gBAAgB;EACpB;;EAEA;IACI,eAAe;IACf,YAAY;EAChB;;EAEA;IACI,eAAe;IACf,gBAAgB;EACpB;;EAEA;IACI,gBAAgB;EACpB;;EAEA;;IAEI,eAAe;IACf,YAAY;EAChB;;EAEA;IACI,gBAAgB;IAChB,eAAe;EACnB;;EAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;EACnB;;EAEA,0DAA0D;;EAC1D;IACI,2BAA2B;IAC3B,+BAA+B;EACnC;;EAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;EAC3B;;EAEA;IACI,uBAAuB;IACvB,wBAAwB;EAC5B;;EAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;EAChC;;EAEA;IACI,0BAA0B;IAC1B,0BAA0B;EAC9B;;EAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,aAAa;EACjB;;EAEA;IACI,mBAAmB;IACnB,mBAAmB;EACvB;;EAEA;IACI,oBAAoB;EACxB;;EAEA;IACI,oBAAoB;EACxB;;EAEA,+BAA+B;;EAC/B;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;EACjC;AACJ;;AAEA,mDAAmD;;AACnD;EACI,yDAAyD;AAC7D;;AAEA;EACI,qBAAqB;AACzB","sourcesContent":["@import 'react-tooltip/dist/react-tooltip.css';\n\nbody,\nbutton,\n.tab-button {\n  -webkit-tap-highlight-color: transparent !important;\n  tap-highlight-color: transparent !important;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* Add focus and active states to prevent highlights */\n.tab-button:focus,\n.tab-button:active,\n.tab-button:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n  -webkit-tap-highlight-color: transparent !important;\n}\n\n/* Prevent blue highlight on active tabs */\n.tab-button.active:focus,\n.tab-button.active:active,\n.tab-button.active:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* Font face declaration for Calibre-Light */\n@font-face {\n  font-family: 'Calibre-Light';\n  src: url('/public/fonts/Calibre-Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* FIXED: Scoped font override instead of aggressive global override */\n.explorer-container,\n.explorer-container div:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container span:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container p:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h1:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h2:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h3:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h4:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h5:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container h6:not(.react-tooltip):not(.react-tooltip *),\n.explorer-container button:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container input:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container select:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container textarea:not(.react-tooltip):not(.react-tooltip *), \n.explorer-container label:not(.react-tooltip):not(.react-tooltip *) {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 300;\n}\n\n/* Apply font to body and html without !important */\nbody, html {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 300;\n}\n\n/* Tooltip-specific font styling - preserves tooltip functionality */\n.react-tooltip,\n.react-tooltip * {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 300 !important;\n  /* Ensure tooltip visibility */\n  position: relative !important;\n  z-index: 10000 !important;\n}\n\n/* Plotly-specific overrides - scoped to your container */\n.explorer-container .plotly .gtitle, \n.explorer-container .plotly .xtitle, \n.explorer-container .plotly .ytitle,\n.explorer-container .plotly .legend, \n.explorer-container .plotly .legendtext,\n.explorer-container .plotly .tick, \n.explorer-container .plotly .ticktext,\n.explorer-container .plotly .annotation, \n.explorer-container .plotly .annotation-text,\n.explorer-container .plotly text, \n.explorer-container .plotly .annotation-text,\n.explorer-container .js-plotly-plot, \n.explorer-container .js-plotly-plot text,\n.explorer-container svg text, \n.explorer-container svg tspan {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 300 !important;\n}\n\n/* Globe.GL and Three.js canvas text (if any) - scoped */\n.explorer-container canvas {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 300 !important;\n}\n\n/* For elements that need to be bold/semibold, override the weight */\n.explorer-container h1, \n.explorer-container h2, \n.explorer-container h3, \n.explorer-container h4, \n.explorer-container h5, \n.explorer-container h6, \n.explorer-container .app-title, \n.explorer-container .header-title,\n.explorer-container .button-primary {\n  font-weight: 400;\n}\n\n/* For very important elements that need more weight */\n.explorer-container .app-title, \n.explorer-container .header-title {\n  font-weight: 500;\n}\n\n/* Super bold title class - keeps Calibre-Light but makes it much bolder */\n.super-bold-title {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 700 !important;\n  font-size: 1.5rem !important;\n  letter-spacing: 0.5px !important;\n  text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.1) !important;\n  color: #1a365d !important;\n}\n\n/* Alternative approach using CSS transforms for even more emphasis */\n.ultra-emphasis {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 700 !important;\n  transform: scaleX(1.05) !important;\n  letter-spacing: 1px !important;\n  text-shadow: 1px 1px 2px rgba(0,0,0,0.15) !important;\n  color: #0f172a !important;\n}\n\n.explorer-container {\n    display: flex;\n    flex-direction: row;\n    height: 100vh;\n    width: 100vw;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n/* ============================================\n   SIDEBAR STYLES - Dark Theme (Framework Visualizer Style)\n   ============================================ */\n.sidebar {\n  width: 320px;\n  background: linear-gradient(180deg, #113743 0%, #0a2029 100%);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  position: relative;\n  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  overflow: visible;\n}\n\n.sidebar.open {\n  width: 320px;\n}\n\n.sidebar.collapsed {\n  width: 48px;\n}\n\n.sidebar.collapsed .sidebar-content {\n  display: none;\n}\n\n.sidebar-content {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.sidebar-toggle {\n  position: absolute;\n  right: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #113743;\n  border: 2px solid white;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  transition: all 0.2s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n}\n\n.sidebar-toggle:hover {\n  background: #1a4f5e;\n  transform: translateY(-50%) scale(1.1);\n}\n\n/* ============================================\n   SECTION STYLES - Dark Theme\n   ============================================ */\n.section {\n  margin-bottom: 1.25rem;\n}\n\n.section-title {\n  font-size: 0.75rem !important;\n  font-weight: 700 !important;  /* Changed from 600 to 700 */\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #E2E8F0 !important;  /* Changed from #94A3B8 to whiter */\n  margin: 0 0 0.5rem 0 !important;\n}\n\n/* ============================================\n   SELECT INPUT STYLES - Dark Theme\n   ============================================ */\n.select-input {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 8px;\n  color: #FFFFFF !important;  /* Ensure pure white */\n  font-size: 0.875rem;\n  font-weight: 500 !important;  /* Add some weight */\n  cursor: pointer;\n  transition: all 0.2s;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23FFFFFF' d='M2 4l4 4 4-4'/%3E%3C/svg%3E\") !important;  /* White arrow */\n  background-repeat: no-repeat !important;\n  background-position: right 0.75rem center !important;\n}\n\n.select-input:hover {\n  background: rgba(255, 255, 255, 0.15) !important;\n  border-color: rgba(255, 255, 255, 0.3) !important;\n}\n\n.select-input:focus {\n  outline: none;\n  border-color: #1a5c6b !important;\n  box-shadow: 0 0 0 2px rgba(17, 55, 67, 0.3);\n}\n\n.select-input option {\n  background: #1E293B;\n  color: white;\n}\n\n.select-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   TAB SELECTOR STYLES - Dark Theme\n   ============================================ */\n.tab-selector {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.tab-button {\n  flex: 1;\n  padding: 0.625rem 0.875rem;\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 8px;\n  color: #94A3B8 !important;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.tab-button:hover {\n  background: rgba(255, 255, 255, 0.15) !important;\n  color: white !important;\n}\n\n.tab-button.active {\n  background: rgba(17, 55, 67, 0.4) !important;\n  border-color: #1a5c6b !important;\n  color: #5ec4d4 !important;\n}\n\n.tab-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Super bold button class for dark theme */\n.super-bold-button {\n  font-family: 'Calibre-Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 0.8125rem !important;\n  letter-spacing: 0.5px !important;\n  text-transform: uppercase !important;\n}\n\n.super-bold-button.active {\n  font-weight: 700 !important;\n}\n\n/* ============================================\n   CHART VIEW SELECTOR - Dark Theme\n   ============================================ */\n.chart-view-selector {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n\n/* ============================================\n   BUTTON STYLES - Dark Theme\n   ============================================ */\n.button {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.button-primary {\n  background-color: #113743;\n  border: none;\n  color: white;\n}\n\n.button-primary:hover {\n  background-color: #1a5c6b;\n}\n\n.button-secondary {\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  color: #CBD5E1 !important;\n}\n\n.button-secondary:hover {\n  background: rgba(255, 255, 255, 0.15) !important;\n  border-color: rgba(255, 255, 255, 0.3) !important;\n  color: white !important;\n}\n\n.button-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   DROPDOWN STYLES - Dark Theme\n   ============================================ */\n.dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dropdown-header:hover {\n  background: rgba(255, 255, 255, 0.15) !important;\n  border-color: rgba(255, 255, 255, 0.3) !important;\n}\n\n.dropdown-search-input {\n  flex: 1;\n  padding: 0.625rem 0.875rem;\n  background: transparent !important;\n  border: none !important;\n  color: #E2E8F0 !important;\n  font-size: 0.875rem;\n  outline: none;\n}\n\n.dropdown-search-input::placeholder {\n  color: #E2E8F0 !important;\n}\n\n.dropdown-arrow {\n  padding: 0 0.75rem;\n  color: #E2E8F0;\n  font-size: 0.625rem;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #1E293B !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n}\n\n.dropdown-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.dropdown-action-button {\n  flex: 1;\n  padding: 0.375rem 0.5rem;\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 4px;\n  color: #CBD5E1 !important;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dropdown-action-button:hover {\n  background: rgba(17, 55, 67, 0.3) !important;\n  color: #5ec4d4 !important;\n}\n\n.dropdown-item {\n  padding: 0.625rem 0.875rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: #E2E8F0 !important;\n  transition: all 0.15s;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.dropdown-item:hover {\n  background: rgba(17, 55, 67, 0.3) !important;\n  color: white !important;\n}\n\n.dropdown-item.selected {\n  background: rgba(17, 55, 67, 0.4) !important;\n  color: #5ec4d4 !important;\n}\n\n.dropdown-item.no-options {\n  color: #64748B !important;\n  cursor: default;\n  justify-content: center;\n}\n\n.dropdown-item.no-options:hover {\n  background: transparent !important;\n}\n\n.dropdown-item input[type=\"checkbox\"] {\n  accent-color: #113743;\n}\n\n.dropdown-section-header {\n  padding: 12px 16px 8px 16px;\n  color: #94A3B8 !important;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background: rgba(255, 255, 255, 0.05) !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  user-select: none;\n  pointer-events: none;\n}\n\n.dropdown-divider {\n  padding: 8px 12px;\n  color: #64748B !important;\n  font-size: 12px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.02) !important;\n  user-select: none;\n  pointer-events: none;\n}\n\n.group-item {\n  padding-left: 24px !important;\n}\n\n/* ============================================\n   INFO ICON STYLES - Dark Theme\n   ============================================ */\n.custom-info-icon {\n  color: #5ec4d4 !important;\n  font-size: 0.875rem;\n  transition: color 0.2s;\n  cursor: help;\n  display: inline-block;\n  line-height: 1;\n}\n\n.custom-info-icon:hover {\n  color: #7dd4e0 !important;\n}\n\n/* Style for the button containing the info icon in sidebar */\n.sidebar button.text-blue-500 {\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: 4px;\n  vertical-align: middle;\n  cursor: help;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.sidebar button.text-blue-500:hover .custom-info-icon {\n  color: #7dd4e0 !important;\n}\n\n.sidebar button.text-blue-500:focus {\n  outline: 2px solid #113743;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* ============================================\n   SCROLLBAR STYLES - Dark Theme for Sidebar\n   ============================================ */\n.sidebar-content::-webkit-scrollbar,\n.sidebar .dropdown-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-content::-webkit-scrollbar-track,\n.sidebar .dropdown-menu::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.sidebar-content::-webkit-scrollbar-thumb,\n.sidebar .dropdown-menu::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb:hover,\n.sidebar .dropdown-menu::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ============================================\n   HEADER STYLES (Legacy - kept for compatibility)\n   ============================================ */\n.header-section {\n    margin-bottom: 16px;\n    flex-shrink: 0;\n}\n\n.header-content {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n}\n\n.title-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    text-align: center;\n}\n\n.app-logo {\n    width: 100%;\n    height: auto;\n    margin-bottom: 10px;\n    display: block;\n    max-width: none;\n}\n\n.app-logo-link {\n    display: block;\n    cursor: pointer;\n    text-decoration: none;\n    width: 100%;\n}\n\n.app-logo-link:hover {\n    opacity: 0.8;\n}\n\n.app-title {\n    font-size: 18px; \n    font-weight: 600;\n    margin: 0;\n    color: white;\n    text-align: center;\n}\n\n/* ============================================\n   TOOLTIP STYLES\n   ============================================ */\n/* Ensure inline-flex container keeps title and icon on the same line */\n.inline-flex.items-center {\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: 4px;\n}\n\n/* ENHANCED TOOLTIP STYLING FOR REACT-TOOLTIP */\n.react-tooltip {\n    position: absolute !important;\n    z-index: 10000 !important;\n    background-color: #1F2937 !important;\n    color: #FFFFFF !important;\n    max-width: 500px !important;\n    min-width: 200px !important;\n    max-height: 350px !important;\n    overflow-y: auto !important;\n    padding: 12px 15px !important;\n    border-radius: 6px !important;\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    word-wrap: break-word !important;\n    hyphens: auto !important;\n    white-space: pre-line !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n    pointer-events: none !important;\n    opacity: 1 !important;\n    transition: opacity 0.2s ease !important;\n}\n\n/* Specific styling for different tooltip placements */\n.react-tooltip[data-place=\"bottom\"] {\n    margin-top: 8px !important;\n}\n\n.react-tooltip[data-place=\"right\"] {\n    margin-left: 8px !important;\n}\n\n.react-tooltip[data-place=\"left\"] {\n    margin-right: 8px !important;\n}\n\n.react-tooltip[data-place=\"top\"] {\n    margin-bottom: 8px !important;\n}\n\n/* Enhanced scrollbar for long tooltip content */\n.react-tooltip::-webkit-scrollbar {\n    width: 6px;\n}\n\n.react-tooltip::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 3px;\n}\n\n.react-tooltip::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.3);\n    border-radius: 3px;\n    transition: background 0.2s ease;\n}\n\n.react-tooltip::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.5);\n}\n\n/* Firefox scrollbar styling */\n.react-tooltip {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);\n}\n\n/* Ensure tooltip content is readable for very long text */\n.react-tooltip p {\n    margin: 0 0 8px 0;\n    line-height: 1.5;\n}\n\n.react-tooltip p:last-child {\n    margin-bottom: 0;\n}\n\n/* Special handling for header tooltips which might be very long */\n[data-tooltip-id=\"header-variable-tooltip\"] + .react-tooltip {\n    max-width: 600px !important;\n    max-height: 400px !important;\n}\n\n/* ============================================\n   YEAR SLIDER STYLES\n   ============================================ */\n.year-slider-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n}\n\n.play-pause-button {\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 0;\n    margin-right: 5px;\n    color: #333;\n    transition: color 0.2s;\n}\n\n.play-pause-button:hover:not(:disabled) {\n    color: #3b82f6;\n}\n\n.play-pause-button:disabled {\n    color: #9ca3af;\n    cursor: not-allowed;\n}\n\n.year-slider {\n    flex-grow: 1;\n    -webkit-appearance: none;\n    appearance: none;\n    height: 8px;\n    background: #d1d5db;\n    border-radius: 4px;\n    outline: none;\n    cursor: pointer;\n}\n\n.year-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #3b82f6;\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0 2px rgba(0,0,0,0.3);\n}\n\n.year-slider::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: #3b82f6;\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0 2px rgba(0,0,0,0.3);\n}\n\n.year-slider:disabled {\n    background: #e5e7eb;\n    cursor: not-allowed;\n}\n\n.year-slider:disabled::-webkit-slider-thumb {\n    background: #9ca3af;\n}\n\n.year-slider:disabled::-moz-range-thumb {\n    background: #9ca3af;\n}\n\n.year-label {\n    min-width: 60px;\n    font-size: 14px;\n    color: #333;\n    text-align: right;\n}\n\n/* Map toggle button */\n.map-toggle-button {\n    display: block;\n    width: 100%;\n    padding: 8px 12px;\n    margin-top: 8px;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    text-align: center;\n    background-color: #e5e7eb;\n    color: #1f2937;\n}\n\n.map-toggle-button:hover {\n    background-color: #d1d5db;\n}\n\n/* ============================================\n   MAIN CONTENT AREA STYLES\n   ============================================ */\n.main-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background-color: white;\n    z-index: 5;\n    position: relative;\n    overflow: hidden;\n    width: auto !important;\n    min-width: 300px;\n    transition: all 0.3s ease;\n}\n\n/* Better responsive width calculations */\n.explorer-container[data-right-panel-open=\"true\"] .main-content {\n    width: calc(100vw - var(--sidebar-width, 320px) - 350px) !important;\n    min-width: 300px;\n}\n\n.explorer-container[data-right-panel-open=\"false\"] .main-content {\n    width: calc(100vw - var(--sidebar-width, 320px)) !important;\n    min-width: 300px;\n}\n\n.header {\n    flex-shrink: 0;\n    width: 100%;\n    padding: 10px 20px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.header-title {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0;\n    color: #111;\n    display: inline;\n    white-space: nowrap;\n}\n\n.header-description {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n}\n\n/* Fix content area to be more responsive */\n.content-area {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    align-items: stretch;\n    min-height: 600px;\n    transition: width 0.3s ease;\n}\n\n/* Map controls */\n.map-controls {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: flex;\n    gap: 10px;\n    z-index: 1000;\n}\n\n.map-controls .button {\n    padding: 6px 10px;\n    font-size: 12px;\n    margin-top: 0;\n}\n\n/* ============================================\n   RIGHT PANEL STYLES\n   ============================================ */\n.right-panel {\n    flex: 0 0 350px;\n    max-width: 350px;\n    background-color: #f9f9f9;\n    border-left: 1px solid #e0e0e0;\n    transition: flex-basis 0.3s ease, max-width 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: 100%;\n    z-index: 20;\n}\n\n.right-panel.collapsed {\n    flex: 0 0 40px;\n    max-width: 40px;\n}\n\n.right-panel.collapsed .panel-content {\n    display: none;\n}\n\n.panel-toggle {\n    position: absolute;\n    top: 20px;\n    left: -15px;\n    background-color: #3b82f6;\n    color: white;\n    border: 2px solid white;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 16px;\n    z-index: 100;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.panel-toggle:hover {\n    background-color: #2563eb;\n}\n\n.panel-toggle-text {\n    background-color: #3b82f6;\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    transition: background-color 0.2s;\n    width: auto;\n    display: inline-block;\n    margin: 10px;\n}\n\n.panel-toggle-text:hover {\n    background-color: #2563eb;\n}\n\n.right-panel.collapsed .panel-toggle-text {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n\n.right-panel.open .panel-toggle-text {\n    position: relative;\n    margin-bottom: 10px;\n}\n\n.panel-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: hidden;\n    position: relative;\n}\n\n/* ============================================\n   METADATA STYLES\n   ============================================ */\n.metadata-toggle-button {\n    background-color: #3b82f6;\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    transition: background-color 0.2s;\n    margin-bottom: 1rem;\n}\n\n.metadata-toggle-button:hover {\n    background-color: #2563eb;\n}\n\n.metadata-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n}\n\n.metadata-popup {\n    background-color: white;\n    border-radius: 8px;\n    padding: 2rem;\n    max-width: 600px;\n    max-height: 80vh;\n    overflow: auto;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.metadata-popup h3 {\n    margin: 0 0 1.5rem 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1F2937;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.metadata-popup button {\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #6B7280;\n}\n\n.metadata-fields {\n    display: grid;\n    gap: 1rem;\n}\n\n.metadata-field {\n    border-bottom: 1px solid #E5E7EB;\n    padding-bottom: 0.75rem;\n}\n\n.metadata-field dt {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 0.25rem;\n}\n\n.metadata-field dd {\n    font-size: 0.875rem;\n    color: #1F2937;\n    margin: 0;\n    word-break: break-word;\n}\n\n.metadata-field a {\n    color: #1a5c6b;\n    text-decoration: underline;\n}\n\n.no-metadata {\n    color: #6B7280;\n    font-style: italic;\n}\n\n/* ============================================\n   TABLE STYLES\n   ============================================ */\n.table-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 10px;\n}\n\n.table-title {\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: #333;\n    flex-shrink: 0;\n}\n\n.table-container {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-width: 100%;\n}\n\n.data-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n}\n\n.data-table thead tr {\n    display: flex;\n    background-color: #f4f4f4;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.data-table th,\n.data-table td {\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n    flex: 1;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #333;\n}\n\n.data-table th {\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.data-table tbody tr {\n    display: flex;\n}\n\n.data-table th:nth-child(1),\n.data-table td:nth-child(1) {\n    flex: 2;\n}\n\n.data-table th:nth-child(2),\n.data-table td:nth-child(2) {\n    flex: 1;\n    text-align: center;\n}\n\n.data-table th:nth-child(3),\n.data-table td:nth-child(3) {\n    flex: 1.5;\n    text-align: right;\n}\n\n.data-table .sort-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    color: #3b82f6;\n    padding: 0;\n    margin-left: 4px;\n}\n\n.data-table .sort-button:hover {\n    color: #2563eb;\n}\n\n.data-table tr.row-even {\n    background-color: #fafafa;\n}\n\n.data-table tr.row-odd {\n    background-color: #ffffff;\n}\n\n.table-footer {\n    font-size: 12px;\n    color: #666;\n    margin-top: 10px;\n    text-align: center;\n    flex-shrink: 0;\n}\n\n/* ============================================\n   MAP VISUALIZATION STYLES\n   ============================================ */\n.map-view-wrapper {\n    position: relative;\n    width: 100%;\n    height: calc(100vh - 120px);\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: stretch;\n    margin-bottom: 0;\n    max-height: calc(100vh - 120px);\n    transition: all 0.3s ease;\n    overflow: hidden;\n}\n\n.map-view-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex: 1;\n    overflow: hidden;\n    z-index: 10;\n    transition: all 0.3s ease;\n}\n\n.map-view-container[data-mode=\"2d\"] .globe-container {\n    display: none;\n}\n\n.map-view-container[data-mode=\"3d\"] .world-map,\n.map-view-container[data-mode=\"3d\"] .legend-container {\n    display: none;\n}\n\n.region-select {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 8px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n    z-index: 1000;\n    cursor: pointer;\n}\n\n/* Fix map visualization container to resize properly */\n.map-visualization-container {\n    width: 100% !important;\n    height: 100% !important;\n    flex: 1 !important;\n    position: relative !important;\n    display: flex !important;\n    justify-content: stretch !important;\n    align-items: stretch !important;\n    min-height: 400px !important;\n    overflow: hidden !important;\n    transition: all 0.3s ease !important;\n}\n\n.map-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f9fafb;\n    color: #6b7280;\n    border-radius: 8px;\n}\n\n.world-map {\n    flex: 0 0 85%;\n    height: 100%;\n    display: block;\n    margin: 0;\n    transition: all 0.3s ease;\n}\n\n.world-map path {\n    transition: fill 0.3s ease, stroke 0.2s ease, stroke-width 0.2s ease;\n}\n\n.world-map path:hover {\n    stroke: #333;\n    stroke-width: 1px;\n    cursor: pointer;\n}\n\n.world-map path.has-data {\n    cursor: pointer;\n}\n\n.globe-container {\n    width: 100%;\n    height: 100%;\n    display: block;\n    z-index: 5;\n    transition: all 0.3s ease;\n}\n\n.map-data-status {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: rgba(255, 255, 255, 0.8);\n    padding: 10px;\n    border-radius: 5px;\n    text-align: center;\n}\n\n.map-error {\n    padding: 20px;\n    background-color: #fff3f3;\n    border: 1px solid #ffcccb;\n    border-radius: 5px;\n}\n\n/* Compact year slider positioning */\n.map-view-container .year-slider-container {\n    position: absolute !important;\n    bottom: 20px !important;\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    background-color: rgba(255, 255, 255, 0.9) !important;\n    border: 1px solid #e0e0e0 !important;\n    border-radius: 20px !important;\n    padding: 8px 16px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;\n    z-index: 1000 !important;\n    width: auto !important;\n    height: auto !important;\n    min-width: 300px !important;\n    max-width: 400px !important;\n    flex-shrink: 0 !important;\n}\n\n/* Compact play button styles */\n.map-view-container .year-slider-container .play-pause-button {\n    width: 24px !important;\n    height: 24px !important;\n    border-radius: 50% !important;\n    border: 1px solid #ccc !important;\n    background-color: #fff !important;\n    cursor: pointer !important;\n    font-size: 10px !important;\n    margin-right: 8px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n/* Compact slider styles */\n.map-view-container .year-slider-container .year-slider {\n    width: 180px !important;\n    margin: 0 8px !important;\n    height: 4px !important;\n    cursor: pointer !important;\n}\n\n/* Compact year label styles */\n.map-view-container .year-slider-container .year-label {\n    min-width: 40px !important;\n    text-align: center !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    color: #333 !important;\n}\n\n.legend-container {\n    flex: 0 0 15%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    transition: all 0.3s ease;\n}\n\n.color-scale {\n    width: 20px;\n    height: 80%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(to top, #6baed6, #f7f7f7, #ef3b2c);\n    border-radius: 4px;\n    position: relative;\n    padding: 4px 0;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n}\n\n.color-scale span {\n    position: relative;\n    font-size: 12px;\n    color: #333;\n    text-align: center;\n    margin: 0 5px;\n    font-weight: 500;\n}\n\n/* ============================================\n   CHART VISUALIZATION STYLES\n   ============================================ */\n.chart-view-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    transition: all 0.3s ease;\n}\n\n.chart-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: #f9fafb;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n}\n\n.chart-control-group {\n    display: flex;\n    flex-direction: column;\n    min-width: 150px;\n}\n\n.chart-control-group label {\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #4b5563;\n}\n\n.chart-select {\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n}\n\n/* Plotly chart container fixes */\n.plotly-chart-container {\n    width: 100% !important;\n    height: 100% !important;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background-color: #ffffff;\n    transition: all 0.3s ease;\n    overflow: hidden;\n}\n\n.no-data-message {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #6b7280;\n    text-align: center;\n}\n\n.plotly-chart {\n    width: 100% !important;\n    height: 100% !important;\n    transition: all 0.3s ease;\n}\n\n/* Filter status */\n.filter-info {\n    font-size: 0.8rem;\n    color: #666;\n    margin-top: 4px;\n    margin-bottom: 0;\n}\n\n.filter-warning {\n    color: #d32f2f;\n    font-weight: bold;\n    margin-top: 4px;\n}\n\n.filter-status {\n    background-color: #f5f5f5;\n    padding: 8px;\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n\n/* Export buttons */\n.export-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n/* Debug controls */\n.debug-controls {\n    margin-top: 15px;\n    display: flex;\n    gap: 10px;\n}\n\n/* Map tooltip */\n.map-tooltip {\n    position: absolute;\n    display: none;\n    padding: 8px 12px;\n    background-color: rgba(0,0,0,0.8);\n    color: white;\n    border-radius: 4px;\n    font-size: 12px;\n    pointer-events: none;\n    z-index: 1000;\n}\n\n/* Loading state */\n.loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100vw;\n}\n\n/* Remove any existing year controls that might be in the main content area */\n.content-area > .year-controls {\n    display: none !important;\n}\n\n/* Year controls - legacy styles (kept for compatibility) */\n.year-controls {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-top: 0;\n    padding: 10px 0;\n    background-color: #f9f9f9;\n    border-top: 1px solid #e0e0e0;\n}\n\n/* ENHANCED TOOLTIP VISIBILITY AND PERFORMANCE FIXES */\n/* Force tooltip to always be visible when active */\n.react-tooltip.show {\n    opacity: 1 !important;\n    visibility: visible !important;\n    pointer-events: none !important;\n}\n\n/* Prevent tooltip content from being cut off */\n.react-tooltip.type-dark {\n    background-color: #1F2937 !important;\n    border: 1px solid #374151 !important;\n}\n\n/* Better contrast for tooltip text */\n.react-tooltip.type-dark.place-top:after,\n.react-tooltip.type-dark.place-bottom:after,\n.react-tooltip.type-dark.place-left:after,\n.react-tooltip.type-dark.place-right:after {\n    border-color: #374151 !important;\n}\n\n/* Ensure tooltip arrows are visible */\n.react-tooltip:after {\n    border-width: 6px !important;\n    margin-left: -6px !important;\n}\n\n/* Special handling for tooltip content with line breaks */\n.react-tooltip br {\n    line-height: 1.8 !important;\n}\n\n/* Enhanced focus states for accessibility */\nbutton[data-tooltip-id]:focus {\n    outline: 2px solid #3b82f6 !important;\n    outline-offset: 2px !important;\n    border-radius: 3px !important;\n}\n\n/* Ensure tooltips work well with screen readers */\nbutton[data-tooltip-id] {\n    position: relative;\n}\n\nbutton[data-tooltip-id]:focus .custom-info-icon,\nbutton[data-tooltip-id]:active .custom-info-icon {\n    color: #93C5FD !important;\n}\n\n.watermarks-container {\n    /* Ensure watermarks stay above other content but below modals */\n    z-index: 1000;\n}\n\n/* ============================================\n   RESPONSIVE STYLES\n   ============================================ */\n@media (max-width: 1200px) {\n    .explorer-container[data-right-panel-open=\"true\"] .main-content {\n        width: calc(100vw - var(--sidebar-width, 320px) - 300px) !important;\n    }\n    \n    .right-panel {\n        flex: 0 0 300px;\n        max-width: 300px;\n    }\n    \n    .sidebar {\n        width: 280px;\n    }\n    \n    .sidebar.open {\n        width: 280px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .explorer-container {\n        flex-direction: column;\n        height: auto;\n    }\n    \n    .sidebar {\n        width: 100% !important;\n        max-width: 100%;\n        border-right: none;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n        max-height: 50vh;\n    }\n\n    .sidebar.collapsed {\n        height: 48px;\n        width: 100% !important;\n        max-height: 48px;\n    }\n\n    .sidebar-toggle {\n        right: 50%;\n        top: auto;\n        bottom: -16px;\n        transform: translateX(50%);\n    }\n\n    .main-content {\n        width: 100% !important;\n        flex: 1;\n        min-height: 500px;\n        min-width: auto;\n    }\n\n    .explorer-container[data-right-panel-open=\"true\"] .main-content,\n    .explorer-container[data-right-panel-open=\"false\"] .main-content {\n        width: 100% !important;\n        min-width: auto;\n    }\n\n    .right-panel {\n        flex: 0 0 auto;\n        width: 100%;\n        max-width: 100%;\n        border-left: none;\n        border-top: 1px solid #e0e0e0;\n        height: auto;\n    }\n\n    .right-panel.collapsed {\n        height: 40px;\n        width: 100%;\n    }\n\n    .panel-toggle {\n        left: auto;\n        right: 10px;\n        top: 20px;\n        transform: none;\n    }\n\n    .panel-toggle-text {\n        right: 10px;\n        top: 10px;\n        margin: 0;\n        width: auto;\n        padding: 6px 12px;\n    }\n\n    .right-panel.open .panel-toggle-text {\n        margin: 10px;\n        width: auto;\n        padding: 6px 12px;\n    }\n\n    .title-wrapper {\n        justify-content: center;\n        padding-right: 0;\n    }\n\n    .app-logo {\n        max-width: 150px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .region-select {\n        top: 5px;\n        right: 5px;\n    }\n\n    .map-controls {\n        flex-direction: column;\n        align-items: flex-end;\n    }\n\n    .world-map {\n        flex: 0 0 100%;\n    }\n\n    .legend-container {\n        flex: 0 0 100%;\n        height: 40px;\n        margin: 10px 0;\n        flex-direction: row;\n    }\n\n    .color-scale {\n        width: 100%;\n        max-width: 400px;\n        height: 20px;\n        flex-direction: row;\n        background: linear-gradient(to right, #6baed6, #f7f7f7, #ef3b2c);\n        padding: 0 10px;\n    }\n\n    .color-scale span {\n        margin: 0;\n    }\n\n    .data-table th,\n    .data-table td {\n        font-size: 11px;\n        padding: 6px;\n    }\n\n    .tab-button {\n        padding: 0.5rem 0.625rem;\n        font-size: 0.75rem;\n        min-width: 60px;\n    }\n\n    /* Responsive adjustments for map view wrapper */\n    .map-view-wrapper {\n        height: calc(100vh - 200px);\n        max-height: calc(100vh - 200px);\n    }\n    \n    .map-view-container .year-slider-container {\n        min-width: 280px !important;\n        max-width: 350px !important;\n        padding: 6px 12px !important;\n    }\n    \n    .map-view-container .year-slider-container .year-slider {\n        width: 160px !important;\n    }\n\n    .metadata-popup {\n        max-width: 500px;\n        width: 90%;\n        padding: 1.5rem;\n    }\n    \n    .watermarks-container {\n        bottom: 10px !important;\n        left: 10px !important;\n        right: 10px !important;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n    \n    .watermarks-container > div {\n        font-size: 10px !important;\n    }\n    \n    .watermarks-container img {\n        height: 30px !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .react-tooltip {\n        max-width: 90vw !important;\n        max-height: 60vh !important;\n        font-size: 12px !important;\n        padding: 10px 12px !important;\n    }\n    \n    [data-tooltip-id=\"header-variable-tooltip\"] + .react-tooltip {\n        max-width: 95vw !important;\n        max-height: 70vh !important;\n    }\n}\n\n@media (max-width: 640px) {\n    .table-container {\n        overflow-x: auto;\n    }\n    \n    .chart-controls {\n        flex-direction: column;\n    }\n    \n    .chart-control-group {\n        width: 100%;\n    }\n\n    .app-title {\n        font-size: 16px;\n    }\n\n    .title-wrapper {\n        padding-right: 0;\n    }\n\n    .region-select {\n        font-size: 12px;\n        padding: 6px;\n    }\n\n    .map-controls .button {\n        font-size: 10px;\n        padding: 4px 8px;\n    }\n\n    .app-logo {\n        max-width: 120px;\n    }\n\n    .data-table th,\n    .data-table td {\n        font-size: 10px;\n        padding: 4px;\n    }\n\n    .panel-toggle-text {\n        padding: 4px 8px;\n        font-size: 12px;\n    }\n\n    .tab-button {\n        padding: 0.375rem 0.5rem;\n        font-size: 0.6875rem;\n        min-width: 50px;\n    }\n\n    /* Mobile responsive adjustments for compact year slider */\n    .map-view-wrapper {\n        height: calc(100vh - 250px);\n        max-height: calc(100vh - 250px);\n    }\n    \n    .map-view-container .year-slider-container {\n        min-width: 250px !important;\n        max-width: 300px !important;\n        padding: 6px 10px !important;\n        bottom: 10px !important;\n    }\n    \n    .map-view-container .year-slider-container .year-slider {\n        width: 140px !important;\n        margin: 0 6px !important;\n    }\n    \n    .map-view-container .year-slider-container .play-pause-button {\n        width: 20px !important;\n        height: 20px !important;\n        font-size: 8px !important;\n        margin-right: 6px !important;\n    }\n    \n    .map-view-container .year-slider-container .year-label {\n        font-size: 11px !important;\n        min-width: 35px !important;\n    }\n\n    .metadata-popup {\n        max-width: 95%;\n        width: 95%;\n        max-height: 85vh;\n        padding: 1rem;\n    }\n\n    .metadata-popup h3 {\n        font-size: 1.125rem;\n        margin-bottom: 1rem;\n    }\n\n    .metadata-field dt {\n        font-size: 0.8125rem;\n    }\n\n    .metadata-field dd {\n        font-size: 0.8125rem;\n    }\n\n    /* Mobile tooltip adjustments */\n    .react-tooltip {\n        max-width: 95vw !important;\n        font-size: 12px !important;\n        padding: 10px 12px !important;\n    }\n}\n\n/* Ensure watermarks don't interfere with sidebar */\n.explorer-container[data-sidebar-open=\"true\"] .watermarks-container {\n    left: calc(var(--sidebar-width, 320px) + 20px) !important;\n}\n\n.explorer-container[data-sidebar-open=\"false\"] .watermarks-container {\n    left: 60px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
